import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.vehMonitor
var driverName = global.driverName
var orderName = global.orderName
// 车辆树
export const cVehicleTree = p => post(driverName + '/cVehicleInfo/cVehicleTree', p)
// 车辆轨迹列表
export const cVehicleListGpsInfo = p => post(name + '/cVehicleGps/cVehicleListGpsInfo', p)
// 查询车辆
export const getCVehicleInfo = p => post(driverName + '/cVehicleInfo/getCVehicleInfo', p)
// 查询行驶信息
export const cVehicleGpsInfo = p => post(name + '/cVehicleGps/cVehicleGpsInfo', p)
// 查询司机位置
export const driverLastHis = p => post(name + '/hisTrack/driverLastHis', p)
// 查询司机信息
export const detailDriver = p => post(driverName + '/cDriverInfo/detail', p)
// 查询车辆历史轨迹
export const vhcHisList = p => post(name + '/hisTrack/vhcHisList', p)
// 中交新路车辆历史轨迹
export const zjVhcHisList = p => post(name + '/hisTrack/zjVhcHisList', p)
// 司机历史轨迹
export const driverHisList = p => post(name + '/hisTrack/driverHisList', p)
// 司机历史详细信息
export const driverHisDataList = p => post(name + '/hisTrack/driverHisDataList', p)
// 地理围栏列表
export const fenceList = p => post(name + '/fence/list', p)
// 添加地理围栏
export const fenceAdd = p => post(name + '/fence/add', p)
// 删除地理围栏
export const fenceDelete = p => post(name + '/fence/delete', p)
// 地理围栏停用启用
export const fenceUpdate = p => post(name + '/fence/update', p)
// 地理围栏编辑
export const updateFence = p => post(name + '/fence/updateFence', p)
// 可查中交新路的实时定位
export const cVehicleRealTimeGpsInfo = p => post(name + '/cVehicleGps/cVehicleRealTimeGpsInfo', p)
// 换车记录
export const changeCarLog = p => post(`/${orderName}/changeCarLog/list`, p)
